import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";

const CustomLogout = () => {
  const storedUrl = localStorage.getItem("URL");

  const handleLoginAgain = () => {
    if (storedUrl) {
      // Ensure the URL has a protocol, defaulting to https
      if (!/^https?:\/\//i.test(storedUrl)) {
        window.location.href = `https://${storedUrl}`;
      } else {
        window.location.href = storedUrl;
      }
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f0f2f5",
      }}
    >
      <Result
        status="success"
        title="Successfully Logged Out"
        subTitle="You have been successfully logged out of your account."
        extra={[
          <Button type="primary" key="login" onClick={handleLoginAgain}>
            Login Again
          </Button>,
        ]}
      />
    </div>
  );
};

export default CustomLogout;
